export default __webpack_public_path__ + "static/media/54_photo.b5997ab9.jpg";